import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, Fragment } from 'react';
import { useGeneratedId } from '../../../utils/index.js';
import { StyledLabel, StyledInputContainer, Input, Overlay, Handle } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Switch = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'checkbox' : _props$type,
    controlledId = props.id,
    label = props.label,
    restProps = __rest(props, ["type", "id", "label"]);
  var autoId = useGeneratedId('switch');
  var id = controlledId || autoId;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [label && /*#__PURE__*/jsx(StyledLabel, {
      htmlFor: id,
      children: label
    }), /*#__PURE__*/jsxs(StyledInputContainer, {
      $size: "small",
      children: [/*#__PURE__*/jsx(Input, _extends({}, restProps, {
        ref: forwardedRef,
        type: type,
        id: id
      })), /*#__PURE__*/jsx(Overlay, {
        children: /*#__PURE__*/jsx(Handle, {})
      })]
    })]
  });
});

export { Switch };
